import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";

/**
 * Auth-only gate (used for the AI questionnaire/recommendations).
 */
export default function ProtectedRoute({ children }) {
  const {
    loading, user, hasSignedAgreement,
    setAuthModalOpen, setAuthModalMode,
    setAgreementModalOpen, setPostAuthRedirect,
  } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      setPostAuthRedirect(location.pathname + location.search);
      setAuthModalMode("signup");
      setAuthModalOpen(true);
    } else if (!hasSignedAgreement) {
      setPostAuthRedirect(location.pathname + location.search);
      setAgreementModalOpen(true);
    }
  }, [loading, user, hasSignedAgreement, location,
      setAuthModalOpen, setAuthModalMode, setAgreementModalOpen, setPostAuthRedirect]);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-gray-500" data-testid="protected-route-loading">
        Loading…
      </div>
    );
  }
  if (!user || !hasSignedAgreement) {
    return <Navigate to="/" replace />;
  }
  return children;
}
